export const FETCH_ANSWERS = "[Answers] Fetch Data";
export const FETCH_USER_EMAIL = "[User] Fetch Data";
